export default __webpack_public_path__ + "static/media/dentist (2).3fdd7935.jpg";